import { makeStylesheetLink } from "../../stylesheet";

export class Register extends HTMLElement {

	shadow: ShadowRoot;

	button: HTMLButtonElement;

	onClick: () => void;

	constructor() {
		super();

		this.shadow = this.attachShadow({ mode: "open" });

		this.button = (
			<button
				type="button"
				className="gct-btn-lg gct-w100"
			>
				Register
			</button>
		) as HTMLButtonElement;

		this.onClick = onClick.bind(this);

		this.shadow.append(
			this.button,
			makeStylesheetLink(),
		);
	}

	connectedCallback() {
		this.button.addEventListener("click", this.onClick);
	}

	disconnectedCallback() {
		this.button.removeEventListener("click", this.onClick);
	}
}

async function onClick(this: Register) {
	try {
		this.button.disabled = true;

		const registerUrl = this.dataset.registerUrl!;

		window.location.href = registerUrl;

	} finally {
		this.button.disabled = false;
	}
}
